<template>
    <div class="login__side">
      <div class="login__side-con">
        <img
          src="../assets/images/background.jpg"
          alt=""
          class="login__side-img"
        />
      </div>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>